import { Controller } from "@hotwired/stimulus";
import consumer from "channels/consumer";

export default class extends Controller {
  static targets = ["overlay", "message"];
  static values = {
    messages: Array
  };

  private messageInterval: number | null = null;
  private currentMessageIndex: number = 0;
  private subscription: any = null;

  connect() {
    // Don't subscribe on connect - wait until show() is called
    // This ensures we only subscribe when actually needed
  }

  disconnect() {
    this.stopMessageRotation();
    this.unsubscribeFromTranslationProgress();
  }

  show() {
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.add("visible");
      this.startMessageRotation();
      
      // Subscribe to ActionCable when showing the overlay
      if (!this.subscription) {
        this.subscribeToTranslationProgress();
      }
    }
  }

  hide() {
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.remove("visible");
      this.stopMessageRotation();
    }
  }

  private startMessageRotation() {
    this.currentMessageIndex = 0;
    this.updateMessage();
    
    // Rotate messages every 3 seconds
    this.messageInterval = window.setInterval(() => {
      this.currentMessageIndex = (this.currentMessageIndex + 1) % this.messagesValue.length;
      this.updateMessage();
    }, 3000);
  }

  private stopMessageRotation() {
    if (this.messageInterval) {
      clearInterval(this.messageInterval);
      this.messageInterval = null;
    }
  }

  private updateMessage() {
    if (this.hasMessageTarget && this.messagesValue.length > 0) {
      this.messageTarget.textContent = this.messagesValue[this.currentMessageIndex];
    }
  }

  private subscribeToTranslationProgress() {
    console.log("Subscribing to TranslationProgressChannel");
    this.subscription = consumer.subscriptions.create("TranslationProgressChannel", {
      connected: () => {
        console.log("Connected to TranslationProgressChannel");
      },
      disconnected: () => {
        console.log("Disconnected from TranslationProgressChannel");
      },
      received: (data: any) => {
        console.log("Received data from TranslationProgressChannel:", data);
        if (data.type === "translation_complete" || data.type === "translation_failed") {
          this.handleTranslationComplete(data);
        }
      }
    });
  }

  private unsubscribeFromTranslationProgress() {
    if (this.subscription) {
      console.log("Unsubscribing from TranslationProgressChannel");
      this.subscription.unsubscribe();
      this.subscription = null;
    }
  }

  private handleTranslationComplete(data: any) {
    console.log("Translation complete, reloading page");
    // Hide overlay and reload the page
    this.hide();
    
    // Small delay before reload for smooth transition
    setTimeout(() => {
      window.location.reload();
    }, 500);
  }
}
